import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { QueryKeys } from '../QueryKeys';
import { getVenues } from 'src/api/getVenues/getVenues';
import { IGetVenuesResponseData } from 'src/api/getVenues/types';

export const useVenues = (): UseQueryResult<IGetVenuesResponseData[]> => {
  const { showSnackbar } = useSnackbar();

  return useQuery({
    queryKey: [QueryKeys.venues],
    queryFn: getVenues,
    onError: () =>
      showSnackbar({
        status: SnackbarStatus.ERROR,
        message: 'Something went wrong whilst fetching venues',
      }),
  });
};
